module.exports = __webpack_public_path__ + "img/argentina.0cb39220.png";